var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('div',{staticClass:"counter__number",class:_vm.counter.color},[_vm._v(_vm._s(_vm.counterValue))]),_c('div',{staticClass:"counter__title"},[_vm._v(_vm._s(_vm.counter.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }